import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminDashboard } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/st-admin/dashboard")({
	component: () => (
		<DashboardLayout>
			<STAdminDashboard />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
